// extracted by mini-css-extract-plugin
export default {"wrap":"ZO-z","subtitle":"_O-z","contentWrap":"aP-z","imgWrap":"bP-z","heading":"cP-z","copy":"dP-z"};